/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitUpdateAssetReportRequest
 */
export interface MonitUpdateAssetReportRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitUpdateAssetReportRequest
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitUpdateAssetReportRequest
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitUpdateAssetReportRequest
     */
    reviewed_by?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitUpdateAssetReportRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitUpdateAssetReportRequest
     */
    external_id?: string;
}

/**
 * Check if a given object implements the MonitUpdateAssetReportRequest interface.
 */
export function instanceOfMonitUpdateAssetReportRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitUpdateAssetReportRequestFromJSON(json: any): MonitUpdateAssetReportRequest {
    return MonitUpdateAssetReportRequestFromJSONTyped(json, false);
}

export function MonitUpdateAssetReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitUpdateAssetReportRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'reviewed_by': !exists(json, 'reviewed_by') ? undefined : json['reviewed_by'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
    };
}

export function MonitUpdateAssetReportRequestToJSON(value?: MonitUpdateAssetReportRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'asset': value.asset,
        'reviewed_by': value.reviewed_by,
        'status': value.status,
        'external_id': value.external_id,
    };
}

